import React, { useState, useEffect, useRef } from "react";
import "../css2/HelprrBoxBreath.css";

const PHASES = [
  { name: "Inhale", duration: 4 },
  { name: "Hold", duration: 4 },
  { name: "Exhale", duration: 4 },
  { name: "Hold", duration: 4 },
];

const breathSound = "/assets/audio/helprr-soft-ambient.mp3"; // from public

export default function HelprrBoxBreath() {
  const [phaseIndex, setPhaseIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(PHASES[0].duration);
  const [isRunning, setIsRunning] = useState(false);
  const [soundOn, setSoundOn] = useState(false);

  const audioRef = useRef(null);

  useEffect(() => {
    if (!isRunning) return;

    const interval = setInterval(() => {
      setTimeLeft((t) => {
        if (t <= 1) {
          const next = (phaseIndex + 1) % PHASES.length;
          setPhaseIndex(next);
          return PHASES[next].duration;
        }
        return t - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, phaseIndex]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (soundOn && isRunning) {
      audio.volume = 0.4;
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  }, [soundOn, isRunning]);

  const current = PHASES[phaseIndex].name;

  return (
    <div className="bb-wrapper">
      <audio ref={audioRef} src={breathSound} loop preload="auto" />

      {/* Tiny sound toggle */}
      <button
        className="bb-sound-toggle"
        onClick={() => setSoundOn((s) => !s)}
      >
        {soundOn ? "🔊" : "🔈"}
      </button>

      {/* Main box */}
      <div className={`bb-box bb-${current.toLowerCase()}`}>
        <div className="bb-phase">{current}</div>
        <div className="bb-timer">{timeLeft}s</div>
      </div>

      {/* Start / Pause */}
      <button
        className="bb-main-btn"
        onClick={() => setIsRunning((r) => !r)}
      >
        {isRunning ? "Pause" : "Start"}
      </button>

      <p className="bb-note">You can stop anytime.</p>
    </div>
  );
}
